export const SUMMIT_WORKSHOP_REGISTRATION_LIMIT = 4;

/**
 * IANA timezone identifier used for all summit programming.
 */
export const SUMMIT_TIME_ZONE = "America/New_York";

/**
 * Destination for the summit VIP upsell offering.
 * Use a relative URL so it works in every deployment environment.
 */
export const SUMMIT_VIP_UPSELL_URL =
  "https://summit.dreamcoachmatch.com/vip-pass";

/**
 * Landing page shown after a participant secures their summit seat.
 */
export const SUMMIT_SPOT_SECURED_REDIRECT_URL =
  "https://summit.dreamcoachmatch.com/spot-secured";
